export const MENU_ITEMS = [
  {
    id: "fried_af_chicken_fingers",
    name: "Fried AF Chicken Fingers",
    tagline: "Like the famous ones. Only better.",
    price: 12,
    image: "/menu/fried_af_chicken_fingers.png",
    ingredients: [
      "Hand-breaded chicken fingers",
      "Fried AF golden & crispy",
      "Secret Mac sauce for dipping",
    ],
    tags: ["New", "Signature"],
  },
  {
    id: "pork_crack_mash_bowl",
    name: "Pork Crack Mash Bowl",
    tagline: "The bowl that ruins all other bowls.",
    price: 14,
    image: "/menu/pork_crack_mash_bowl.png",
    ingredients: [
      "Cream cheese mashed potatoes",
      "Smoked pulled pork",
      "Velveeta & fiesta cheese",
      "Crispy bacon bits",
      "Green onion",
    ],
    tags: ["New", "Loaded"],
  },
  {
    id: "betty_cracker_chicken_bowl",
    name: "Betty Cracker Chicken Mashed Potato Bowl",
    tagline: "The bowl Betty never saw coming.",
    price: 14,
    image: "/menu/betty_cracker_chicken_bowl.png",
    ingredients: [
      "Mashed potatoes on the bottom",
      "Diced chicken",
      "Nacho cheese",
      "BBQ sauce",
      "Bacon bits",
      "Green onions",
    ],
    tags: ["New", "Loaded"],
  },
  {
    id: "german_bratwurst",
    name: "Grilled German Bratwurst",
    tagline: "Grilled loud. Snaps louder.",
    price: 7,
    image: "/oktoberfest/bratwurst.png",
    ingredients: [
      "Grilled bratwurst",
      "Toasted roll",
      "Your pick of topping",
    ],
    tags: ["New"],
    dips: {
      label: "Pick your toppings — choose any",
      multi: true,
      default: "mustard",
      choices: [
        { id: "mustard", name: "Stone Ground Mustard" },
        { id: "kraut", name: "Sauerkraut" },
      ],
    },
  },
  {
    id: "bbq_pizza",
    name: "Smokey AF BBQ Pizza",
    tagline: "The whole damn smokehouse on a crust.",
    price: 16,
    image: "/menu/bbq_pizza.png",
    ingredients: [
      "Chipotle sauce base",
      "Melted mozzarella",
      "Slow-smoked pulled pork",
      "Second layer of cheese",
      "BBQ sauce drizzle",
      "Crispy bacon bits",
      "Oven-fired crust",
    ],
    tags: ["Signature", "Wood-Fired"],
  },
  {
    id: "bbq_boat",
    name: "BBQ Boat",
    tagline: "Signature steak rolls. Loaded.",
    price: 14,
    image: "/menu/bbq_boat_hero.png",
    ingredients: [
      "Buttered, toasted steak rolls",
      "Slow-smoked pulled pork",
      "Mild chipotle cheese sauce",
      "BBQ sauce drizzle",
      "Creamy minced coleslaw",
    ],
    tags: ["Signature", "Crowd Favorite"],
  },
  {
    id: "bbq_bavarian_pretzel",
    name: "BBQ Bavarian Behemoth Pretzel",
    tagline: "A pretzel the size of your face.",
    price: 12,
    image: "/menu/bbq_bavarian_pretzel.png",
    ingredients: [
      "Oversized soft Bavarian pretzel",
      "BBQ-butter glaze",
      "Coarse pretzel salt",
      "Smoky BBQ dipping sauce",
      "Beer-cheese dipping sauce",
    ],
    tags: ["New", "Shareable", "Signature"],
    dips: {
      label: "Pick your sauce",
      default: "cheese",
      choices: [
        { id: "cheese", name: "Cheese Sauce" },
        { id: "honey_mustard", name: "Honey Mustard" },
      ],
    },
  },
  {
    id: "pulled_pork_sandwich",
    name: "Pulled Pork Sandwich",
    tagline: "The classic. Done right.",
    price: 14,
    image:
      "https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/ea2515a2333c003b27a647814b302029d3cce5e873cb14aabd10c36f28866c54.png",
    ingredients: [
      "Toasted brioche bun",
      "Mountain of pulled pork",
      "Tangy coleslaw",
      "Side of speared fries",
    ],
    tags: ["Classic"],
  },
  {
    id: "japanese_bbq_burger",
    name: "Japanese BBQ Burger",
    tagline: "Inch-and-a-quarter of smoked beef glory.",
    price: 14,
    image:
      "https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/7bf2ff7d38aa446f0d911781f9ff37801a21fc0c06fdec41228765bfa8ea3d62.png",
    ingredients: [
      '1¼" thick smoked patty',
      "House mayo",
      "Japanese BBQ sauce",
      "Side of speared fries",
    ],
    tags: ["Smoked", "Bold"],
  },
  {
    id: "loaded_pork_fries",
    name: "Loaded Pork Fries",
    tagline: "Straight-cut. Loaded. Drowned in BBQ.",
    price: 14,
    image: "/menu/loaded_pork_fries.png",
    ingredients: [
      "Straight-cut fries, hot & fresh",
      "Hot fresh pulled pork",
      "Hot nacho cheese",
      "BBQ sauce drizzle",
      "Hot crispy bacon bits",
      "Green onions",
    ],
    tags: ["Shareable", "Loaded"],
    addons: [{ id: "jalapenos", name: "Add Jalapeños", price: 1 }],
  },
  {
    id: "mini_pulled_pork_sandwich",
    name: "Mini Pulled Pork Sandwich",
    tagline: "Smaller bite. Same heat.",
    price: 7,
    image: "/menu/mini_pulled_pork_sandwich.png",
    ingredients: [
      "Toasted slider bun",
      "Smoked pulled pork",
      "Tangy coleslaw",
      "BBQ drizzle",
    ],
    tags: ["Mini"],
  },
  {
    id: "mini_bbq_boat",
    name: "Mini BBQ Boat",
    tagline: "One bun. One mission.",
    price: 7,
    image: "/menu/mini_bbq_boat.png",
    ingredients: [
      "One toasted hot dog bun",
      "Smoked pulled pork",
      "Chipotle sauce",
      "House coleslaw",
    ],
    tags: ["Mini"],
  },
  {
    id: "nacho_pork_sandwich",
    name: "Nacho Jalapeño Pulled Pork Sandwich",
    tagline: "Cheese-soaked. Pepper-pop. No slaw.",
    price: 10,
    image: "/menu/nacho_pork_sandwich.png",
    ingredients: [
      "Toasted brioche bun",
      "Smoked pulled pork",
      "Nacho cheese sauce",
      "Sliced jalapeños",
    ],
    tags: ["New", "Spicy"],
  },
  {
    id: "japanese_pork_sandwich",
    name: "Japanese Pulled Pork Sandwich",
    tagline: "The classic — with a Tokyo twist.",
    price: 10,
    image: "/menu/japanese_pork_sandwich.png",
    ingredients: [
      "Toasted brioche bun",
      "Smoked pulled pork",
      "Japanese BBQ sauce",
      "Tangy coleslaw",
    ],
    tags: ["New", "Smoked"],
  },
  {
    id: "nacho_pork_pizza",
    name: "Smokey AF Nacho Jalapeño Pork Pizza",
    tagline: "Pizza, but with nacho cheese. No mistakes.",
    price: 16,
    image: "/menu/nacho_pork_pizza.png",
    ingredients: [
      "Wood-fired crust",
      "Nacho cheese base",
      "Smoked pulled pork",
      "Sliced jalapeños",
      "Fiesta cheese blend",
    ],
    tags: ["New", "Spicy", "Wood-Fired"],
  },
  {
    id: "bbq_sushi",
    name: "BBQ Sushi",
    tagline: "Yes, you read that right.",
    price: 10,
    image: "/menu/bbq_sushi.png",
    ingredients: [
      "Sushi rice & nori",
      "Smoked pulled pork",
      "Purple peppers",
      "Japanese BBQ dipping sauce",
    ],
    tags: ["New", "Fusion"],
  },
  {
    id: "jerk_chicken_sushi",
    name: "Rastafarian Jerk Chicken Sushi Roll",
    tagline: "Island heat. Rolled tight.",
    price: 10,
    image: "/menu/jerk_chicken_sushi.png",
    ingredients: [
      "Sushi rice & nori",
      "Charred jerk-seasoned chicken",
      "Sweet mango strips",
      "Spicy jerk aioli drizzle",
      "Scallions",
    ],
    tags: ["New", "Fusion", "Spicy"],
  },
  {
    id: "pepperoni_pizza",
    name: "Pepperoni Pizza",
    tagline: "The one that needs no introduction.",
    price: 16,
    image: "/menu/pepperoni_pizza.png",
    ingredients: [
      "Wood-fired crust",
      "Red sauce",
      "Melted mozzarella",
      "Crispy curled pepperoni",
    ],
    tags: ["New", "Wood-Fired"],
  },
  {
    id: "chicken_alfredo_pizza",
    name: "Chicken Alfredo Pizza",
    tagline: "White sauce. Big flavor.",
    price: 16,
    image: "/menu/chicken_alfredo_pizza.png",
    ingredients: [
      "Wood-fired crust",
      "Creamy Alfredo base",
      "Grilled chicken",
      "Mozzarella & Parmesan",
      "Fresh parsley",
    ],
    tags: ["New", "Wood-Fired"],
  },
  {
    id: "garlic_parmesan_wings",
    name: "Garlic Parmesan Wings",
    tagline: "Six bone-in. Buttery garlic glow-up.",
    price: 12,
    image: "/menu/garlic_parmesan_wings.png",
    ingredients: [
      "6 bone-in wings",
      "Garlic Parmesan butter",
      "Fresh Parmesan",
      "Chopped parsley",
    ],
    tags: ["New", "Wings"],
  },
  {
    id: "bbq_wings",
    name: "BBQ Wings",
    tagline: "Six bone-in. Lacquered in smoke.",
    price: 12,
    image: "/menu/bbq_wings.png",
    ingredients: [
      "6 bone-in wings",
      "House BBQ sauce",
      "Green onions",
      "Sesame seeds",
    ],
    tags: ["New", "Wings"],
  },
  {
    id: "buffalo_wings",
    name: "Buffalo Wings",
    tagline: "Six bone-in. Bring the heat.",
    price: 12,
    image: "/menu/buffalo_wings.png",
    ingredients: [
      "6 bone-in wings",
      "Fiery buffalo sauce",
      "Ranch & celery on the side",
      "Blue cheese crumbles",
    ],
    tags: ["New", "Wings", "Spicy"],
  },
  {
    id: "chipotle_firecracker_wings",
    name: "Garlic Parm Chipotle Firecracker Wings",
    tagline: "Garlic parm meets smoky chipotle heat.",
    price: 12,
    image: "/menu/chipotle_firecracker_wings.png",
    ingredients: [
      "6 bone-in wings",
      "Chipotle-garlic firecracker sauce",
      "Shaved parmesan",
      "Roasted garlic bits",
      "Red pepper flakes",
    ],
    tags: ["New", "Wings", "Spicy"],
  },
  {
    id: "chicken_bacon_ranch_pizza",
    name: "Chicken Bacon Ranch Pizza",
    tagline: "Cool, creamy, smoky.",
    price: 16,
    image: "/menu/chicken_bacon_ranch_pizza.png",
    ingredients: [
      "Wood-fired crust",
      "Ranch base",
      "Grilled chicken",
      "Crispy bacon",
      "Mozzarella",
    ],
    tags: ["New", "Wood-Fired"],
  },
  {
    id: "bbq_chicken_sandwich",
    name: "BBQ Chicken Sandwich",
    tagline: "Crispy breaded chicken. Glazed in BBQ.",
    price: 10,
    image: "/menu/bbq_chicken_sandwich.png",
    ingredients: [
      "Toasted brioche bun",
      "Crispy breaded chicken breast",
      "BBQ sauce",
      "Mayo",
      "Lettuce & tomato",
    ],
    tags: ["New"],
  },
  {
    id: "order_of_fries",
    name: "Order of Fries",
    tagline: "Straight-cut. Extra crispy.",
    price: 5,
    image: "/menu/order_of_fries.png",
    ingredients: [
      "Hand-cut straight fries",
      "Fried extra-crispy",
      "Coarse sea salt",
      "Ketchup on the side",
    ],
    tags: ["New", "Side"],
    dips: {
      label: "Pick your dip",
      default: "ketchup",
      choices: [
        { id: "ranch", name: "Ranch" },
        { id: "cheese", name: "Cheese Sauce" },
        { id: "ketchup", name: "Ketchup" },
      ],
    },
  },
  {
    id: "dessert_pizza",
    name: "Streusel Dessert Pizza",
    tagline: "Old-school pizza shop dessert. Sweet AF.",
    price: 14,
    image: "/menu/dessert_pizza.png",
    ingredients: [
      "Sweet fruit filling — your pick",
      "Buttery streusel crumble",
      "Vanilla icing drizzle",
    ],
    tags: ["New", "Dessert"],
    dips: {
      label: "Pick your filling",
      default: "apple",
      choices: [
        { id: "apple", name: "Apple" },
        { id: "cherry", name: "Cherry" },
      ],
    },
  },
];

export const SPECIAL_ITEMS = [
  {
    id: "pulled_pork_special",
    name: "The Midnight Special",
    tagline: "$5 pulled pork sandwich. Just the sandwich. All the smoke.",
    price: 5,
    image: "/menu/pulled_pork_special.png",
    ingredients: [
      "Toasted brioche bun",
      "Smoked pulled pork",
      "Tangy coleslaw",
      "BBQ drizzle",
      "No sides — just the sandwich",
    ],
    tags: ["Special", "Limited Time"],
  },
  {
    id: "student_loan_special",
    name: "The Student Loan Special",
    tagline: "$5 single BBQ Boat. College night, budget approved.",
    price: 5,
    image: "/menu/student_loan_special.png",
    ingredients: [
      "One buttered, toasted steak roll",
      "Slow-smoked pulled pork",
      "Mild chipotle cheese sauce",
      "BBQ sauce drizzle",
      "Creamy minced coleslaw",
    ],
    tags: ["Special", "College Night"],
  },
];

export const TAVERN_ITEMS = [
  {
    id: "tavern_cheese_pizza",
    name: "Tavern Cheese Pizza",
    short: "Cheese",
    tagline: "Cracker crust. Ultra thin. Ultra crispy.",
    price: 16,
    image: "/menu/tavern_cheese_pizza.png",
    ingredients: [
      "Ultra-thin cracker crust",
      "Bubbling golden cheese to the edge",
      "Square tavern cut",
    ],
    tags: ["New", "Tavern Style"],
  },
  {
    id: "tavern_pepperoni_pizza",
    name: "Tavern Pepperoni Pizza",
    short: "Pepperoni",
    tagline: "Cracker crust. Crispy pepperoni cups.",
    price: 16,
    image: "/menu/tavern_pepperoni_pizza.png",
    ingredients: [
      "Ultra-thin cracker crust",
      "Crispy curled pepperoni",
      "Square tavern cut",
    ],
    tags: ["New", "Tavern Style"],
  },
  {
    id: "hot_honey_jalapeno_pizza",
    name: "Smokey AF Hot Honey Jalapeño Pizza",
    short: "Hot Honey Jalapeño",
    tagline: "Pepperoni. Jalapeños. Hot honey. Cracker crust.",
    price: 16,
    image: "/menu/hot_honey_jalapeno_pizza.png",
    ingredients: [
      "Ultra-thin cracker crust",
      "Crispy pepperoni & jalapeños",
      "Hot honey drizzle",
      "Square tavern cut",
    ],
    tags: ["New", "Tavern Style", "Sweet Heat"],
  },
];

export const DESSERT_ITEM = {
  id: "fried_oreos",
  name: "Forbidden AF Fried Oreos",
  tagline: "Battered. Deep-fried. Absolutely forbidden.",
  price: 6,
  image: "/menu/fried_oreos.png",
  ingredients: [
    "3 batter-dipped Oreos",
    "Fried to a golden puck",
    "Powdered sugar dust",
    "Chocolate drizzle",
  ],
  tags: ["New", "Dessert"],
};

export const FISH_ITEM = {
  id: "fried_fish_plate",
  name: "Fried Fish Plate",
  tagline: "Beautifully breaded. Fries & slaw included.",
  price: 10,
  image: "/menu/fried_fish_plate.png",
  ingredients: [
    "Beautifully breaded fried fish",
    "Straight-cut fries",
    "Creamy coleslaw",
    "Lemon wedge",
  ],
  tags: ["House Special"],
};

export const BOMBS_ITEM = {
  id: "flapjack_chicken_bombs",
  name: "Flapjack Chicken Bombs",
  tagline: "Chicken & waffles, but better.",
  price: 10,
  image: "/menu/flapjack_chicken_bombs.png",
  ingredients: [
    "2 chicken tenders dunked in pancake batter & fried into bombs",
    "Each one the size of a deck of cards",
    "Powdered sugar dust",
    "Warm syrup for dipping",
  ],
  tags: ["New", "Sweet & Savory"],
};

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/6af67451081b51d4a4f8eb30c57353588e1068478daeea247165e77d5501f34a.png";

export const SMOKE_TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/75ef80a31e47adbf6def22c392f59afaa6d7bf6b491879af3fd267a370caa8e9.png";
